import React from "react";

import "./HLines.less";
const HLines = () => {
  return <div className="hLine" />;
};

export default HLines;
